module.exports = __webpack_public_path__ + "static/media/sprite.c73e3a2e.jpg";